import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";

class Contact extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const resumedownload = this.props.data.resumedownload;
    const phone = this.props.data.phone;
    const message = this.props.data.contactmessage;
    const gmail = this.props.data.email;
    const github = this.props.data.github;
    const gmail_path = this.props.data.email_path;
    const social_path = "images/social/";

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="ten columns">
              <p className="lead">{message}</p>
            </div>
          </div>
        </Fade>

        <div className="row">
          <Slide left duration={1000}>
            <div className="seven columns">
              <div className="widget widget_contact">
                  <h4>Contact Info</h4>
                  <p className="address">
                    <a><i className="fa fa-user"></i>{name}</a>
                    <br />
                    <a target="_blank" href="mailto:">
                      <i className="fa fa-envelope-o"></i>
                      {gmail}
                    </a>
                    <br />
                    <a target="_blank" href={resumedownload}><i className="fa fa-linkedin"></i>{resumedownload}</a>
                    <br />
                    <a target="_blank" href={github}><i className="fa fa-github"></i>{github}</a>
                    <br/>
                    <a><i className="fa fa-phone"></i>{phone}</a>
                  </p>
                  <div className="social-group"></div>
                </div>

              <div id="message-warning"> Error boy</div>
              <div id="message-success">
                <i className="fa fa-check"></i>Your message was sent, thank you!
                <br />
              </div>
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="five columns footer-widgets">
              <div className="widget widget_tweets">
                <h4 className="widget-title">Latest Strengths</h4>
                <ul id="twitter">
                  <li>
                    <span>
                    Frontend Developer. Five or seven-years work experience with Javascript framework just like React, Redux, Angular, Typescript, HTML/CSS and familiar with UI/UX design and practice. 
                    </span>
                  </li>
                  <li>
                    <span>
                    Worked for e-commerce websites, and have a great passion for backend with Nodejs, RESTful API, MongoDBm MySql, GraphQl . Familiar with frontend and full-stack technologies.
                    </span>
                  </li>
                </ul>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
